import { render, staticRenderFns } from "./InquiryAnswerFileViewer.vue?vue&type=template&id=69b08ecd&scoped=true&"
import script from "./InquiryAnswerFileViewer.vue?vue&type=script&lang=ts&"
export * from "./InquiryAnswerFileViewer.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryAnswerFileViewer.vue?vue&type=style&index=0&id=69b08ecd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b08ecd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
